// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadExcel_downloadButton__3EHyM"};